import constants from '@/modules/constants';

// Pages that create a new interpretation assignment (including `?copy=`). Enterprises
// migrated to Proweb are sent there instead; editing and cancelling stay here.
export const PROWEB_BLOCKED_ROUTES = [
  'BuyerSelectAssignmentType',
  'BuyerPostInterpretation',
  'BuyerPostFastInterpretation',
  'BuyerPostSeriesInterpretation',
  'BuyerPostSecretaryInterpretation'
];

// Rebooking after a dangerous edit cancelled the original assignment is still allowed
export const isProwebBlockedRoute = (route) => {
  return PROWEB_BLOCKED_ROUTES.includes(route.name) && route.query?.dangerousEdit !== 'true';
};

export const redirectToProweb = () => {
  window.location.assign(constants.PROWEB_URL);
};
